/**
 * ServiceTitan Integration API
 * 
 * Endpoints for managing ServiceTitan connection, sync, mappings, and jobs.
 * Uses the main api instance from api.js to leverage auth interceptors.
 */
import api from './api';

export const serviceTitanAPI = {
  // Connection Management
  getStatus: () => api.get('/integrations/servicetitan/status'),
  connect: (data) => api.post('/integrations/servicetitan/connect', data),
  disconnect: () => api.post('/integrations/servicetitan/disconnect'),
  updateSettings: (data) => api.patch('/integrations/servicetitan/settings', data),
  
  // Sync Management
  triggerSync: (data = {}) => api.post('/integrations/servicetitan/sync', data),
  getSyncHistory: (limit = 20) => api.get('/integrations/servicetitan/sync/history', { params: { limit } }),
  
  // Entity Mapping
  getMappings: (params = {}) => api.get('/integrations/servicetitan/mappings', { params }),
  getPendingMappings: () => api.get('/integrations/servicetitan/mappings/pending'),
  updateMapping: (mappingId, data) => api.patch(`/integrations/servicetitan/mappings/${mappingId}`, data),
  
  // Jobs (Read-only)
  getJobs: (params = {}) => api.get('/integrations/servicetitan/jobs', { params }),
  getJob: (jobId) => api.get(`/integrations/servicetitan/jobs/${jobId}`),
};

export default serviceTitanAPI;
